import DefaultActivityTypeName from "@mapmycustomers/shared/enum/activity/DefaultActivityTypeName";
import { Activity } from "@mapmycustomers/shared/types/entity";

const isAutoEmailActivity = (activity?: Activity): boolean =>
  activity?.crmActivityType.name === DefaultActivityTypeName.EMAIL && !!activity?.emailLog;

export default isAutoEmailActivity;
